import styled from 'styled-components';
import { FormContainer } from '../Loaders/FormLoader';
import BilledFilterControlled from './BilledFilterControlled';
import DateFilterControlled from './DateFilterControlled';
import ShipmentTypeFilterControlled from './ShipmentTypeFilterControlled';
import TankSelectorControlled from './TankSelectorControlled';

export const FilterContainer = styled(FormContainer)`
  margin-bottom: 15px;
`;

export const ButtonColumn = styled.div`
  display: flex;
  align-items: center;
  margin-top: 38px;
  margin-right: 15px;

  button {
    margin-right: 15px;
  }
`;

// Controlled components (URL params)
export { BilledFilterControlled, DateFilterControlled, ShipmentTypeFilterControlled, TankSelectorControlled };
export type { DateFilterValues } from './DateFilterControlled';
export type { TankFilterValues } from './TankSelectorControlled';
